<script setup lang="ts">
import { ref } from 'vue'
import EmailPasswordCard from '@/views/auth/components/EmailPasswordCard.vue'
import PinInputCard from '@/views/auth/components/PinInputCard.vue'
import { useRouter } from 'vue-router'
import ForgotPasswordCard from '@/views/auth/components/ForgotPasswordCard.vue'
import ResetPasswordCard from '@/views/auth/components/ResetPasswordCard.vue'
import OktaLogin from '@/views/auth/components/OktaLogin.vue'
import EntraLogin from '@/views/auth/components/EntraLogin.vue'
import { AuthService } from '@/services/auth.ts'

const stepIndex = ref<number>(0)
const tempAuthToken = ref<string>('')
const optUseEmail = ref<boolean>(false)

const router = useRouter()
if (router.currentRoute.value.name === 'ResetPassword') {
  stepIndex.value = 3
}

async function onLoginSuccess(values: { tempAuthToken: string, otpUseEmail: boolean }) {
  stepIndex.value = 1
  tempAuthToken.value = values.tempAuthToken
  optUseEmail.value = values.otpUseEmail
}

async function onOtpSuccess() {
  await router.replace(AuthService.consumeRedirectUrl())
}
</script>

<template>
  <div class="min-h-screen grid lg:grid-cols-2 grow">
    <div class="flex justify-center items-center p-6">
      <EmailPasswordCard
        v-if="stepIndex === 0"
        @success="onLoginSuccess"
        @forgot-password="stepIndex = 2"
        @login-with-okta="stepIndex = 4"
        @login-with-entra="stepIndex = 5"
      />
      <PinInputCard
        v-if="stepIndex === 1"
        :temp_auth_token="tempAuthToken"
        :otp_use_email="optUseEmail"
        @success="onOtpSuccess"
        @back="stepIndex = 0"
      />
      <ForgotPasswordCard v-if="stepIndex === 2" @back="stepIndex = 0" />
      <ResetPasswordCard v-if="stepIndex === 3" @back="stepIndex = 0" />
      <OktaLogin v-if="stepIndex === 4" @back="stepIndex = 0" />
      <EntraLogin v-if="stepIndex === 5" @back="stepIndex = 0" />
    </div>

    <div class="flex items-center rounded-xl m-6 bg-no-repeat branded-bg">
      <div class="flex flex-col p-8 lg:p-16 gap-6">
        <a href="/">
          <img src="/src/assets/media/revio/horizontal.svg" class="h-[32px] max-w-none" alt="" />
        </a>
        <div class="flex flex-col gap-3 lg:mt-10">
          <h3 class="text-lg lg:text-2xl font-semibold text-gray-900">
            The simplest way to discover deposit and revenue growth opportunities.
          </h3>
          <div class="text-base font-medium text-gray-600">
            Revio Insight <span class="text-gray-900 font-semibold">unlocks customer growth</span>
            with a focus on targeted engagement, cross sell enablement, opportunity identification,
            and product opportunity analysis by leadership, marketers, and frontline bankers.
          </div>
        </div>
        <img
          src="/src/assets/media/revio/print.png"
          style="margin-left: -12px; margin-right: -12px; max-width: calc(100% + 24px)"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.branded-bg {
  background: linear-gradient(0deg, rgba(247, 240, 235, 1) 0%, rgba(238, 243, 252, 1) 100%);
}
</style>
